<template>
    <rkm-modal
        :title="impressao ? impressao.text : ''"
        extra-large
        persistent
        ref="RkmModal"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-button
                    @click="toogleAll"
                    color="primary"
                >
                    {{ isAllSelected ? 'Desmarcar' : 'Selecionar' }} todos
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-list
            :accordion="false"
            :items="prescricoesMedicamentos"
            class="mt-2"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col>
                        <strong>Data / Hora</strong><br />{{item.dataHora}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                    </rkm-col>

                    <rkm-col>
                        <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.codigo}} - {{item.lotacao.ocupacao.nome}}
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <div class="p-2">
                    <rkm-list
                        :items="item.medicamentos"
                        hide-filters
                        hide-pagination
                        item-cursor="default"
                        class="p-2"
                    >
                        <template v-slot="{item}">
                            <rkm-row>
                                <rkm-col
                                    cols="auto"
                                    class="my-auto"
                                >
                                    <rkm-form-checkbox v-model="item.checked" />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-row v-if="item.isManual">
                                        <rkm-col>
                                            <strong>Descrição</strong><br/>
                                            <div v-html="formatDescricao(item.descricao)"></div>
                                        </rkm-col>
                                        <rkm-col v-if="item.justificativa">
                                            <strong>Justificativa</strong><br/>
                                            <div v-html="formatDescricao(item.justificativa)"></div>
                                        </rkm-col>
                                        <rkm-col v-else>
                                            <strong>Justificativa</strong><br/>
                                            -
                                        </rkm-col>
                                    </rkm-row>

                                    <template v-else>
                                        <rkm-row>
                                            <rkm-col cols="3">
                                                <strong>Medicamento</strong><br/>{{item.materialDescricao}}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Via de administração</strong><br/>{{item.materialViaAdministracao}}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Posologia</strong><br/>{{item.posologia}}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Dose única</strong><br/>{{item.isDoseUnica ? 'Sim' : 'Não'}}
                                            </rkm-col>
                                        </rkm-row>

                                        <rkm-row>
                                            <rkm-col cols="3">
                                                <strong>Uso contínuo</strong><br/>{{item.isUsoContinuo ? 'Sim' : 'Não'}}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Início do tratamento</strong><br/>{{item.inicio}}
                                            </rkm-col>

                                            <rkm-col
                                                v-if="!item.isUsoContinuo"
                                                cols="3"
                                            >
                                                <strong>Duração</strong><br/>{{item.duracaoDescricao}}
                                            </rkm-col>

                                            <rkm-col
                                                v-if="item.conclusao"
                                                cols="3"
                                            >
                                                <strong>Conclusão do tratamento</strong><br/>{{item.conclusao}}
                                            </rkm-col>
                                        </rkm-row>
                                    </template>

                                    <rkm-row>
                                        <rkm-col>
                                            <strong>Recomendações</strong><br/>
                                            <div v-html="formatDescricao(item.recomendacoes || '&nbsp;')"></div>
                                        </rkm-col>
                                    </rkm-row>

                                    <template v-if="!item.isManual && item.isTratamentoInterrompido">
                                        <rkm-row>
                                            <rkm-col cols="3">
                                                <strong>Tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoEm}}
                                            </rkm-col>
                                        </rkm-row>

                                        <rkm-row>
                                            <rkm-col>
                                                <strong>Justificativa do tratamento interrompido</strong><br/>{{item.tratamentoInterrompidoJustificativa}}
                                            </rkm-col>
                                        </rkm-row>
                                    </template>
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-list>
                </div>
            </template>
        </rkm-list>

        <template v-slot:footer>
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="isAllUnselected"
                @click="confirm"
                color="primary"
            >
                Confirmar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    computed: {
        isAllSelected() {
            return this.prescricoesMedicamentos.every(p => p.medicamentos.every(m => m.checked))
        },
        isAllUnselected() {
            return this.prescricoesMedicamentos.every(p => p.medicamentos.every(m => !m.checked))
        }
    },
    data: () => ({
        impressao: null,
        prescricoesMedicamentos: [],
    }),
    methods: {
        open(impressao) {
            this.impressao = impressao
            this.prescricoesMedicamentos = this.clone(impressao.data)

            this.$refs.RkmModal.show()
        },
        toogleAll() {
            const check = !this.isAllSelected

            this.prescricoesMedicamentos.forEach(p => p.medicamentos.forEach(m => m.checked = check))
        },
        confirm() {
            this.impressao.data = this.prescricoesMedicamentos
            this.close()
        },
        cancel() {
            this.close()
            this.$emit('cancel')
        },
        close() {
            this.$refs.RkmModal.hide()
        },
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
    },
    mixins: [object],
}
</script>